import { useEffect, useState } from 'react';

import axios from 'axios';
import Honeybadger from '@honeybadger-io/js';
import { loadConnectAndInitialize } from '@stripe/connect-js';

import { STRIPE_CONNECT_SESSION } from '../api';

const googleFontsUrl = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700';

const appearance = {
  variables: {
    fontFamily: 'Montserrat, sans-serif',
  },
};

// There is no need to display a loading spinner or error messages. Stripe provides both
// in components where this hook is used.
const useStripeConnect = () => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);

  const fetchClientSecret = async () => {
    const response = await axios.post(STRIPE_CONNECT_SESSION).catch((error) => {
      // If errors occur here, #loadConnectAndInitialize (a Stripe method that calls
      // #fetchClientSecret) will not properly propogate the error. Therefore, in
      // addition to the try/catch block surrounding #loadConnectAndInitialize, a second
      // catch has been added to #fetchClientSecret.
      Honeybadger.notify(error);
    });

    if (response?.status === 200) {
      return response.data.client_secret;
    }

    return undefined;
  };

  useEffect(() => {
    const initializeStripe = async () => {
      try {
        const instance = await loadConnectAndInitialize({
          publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
          fonts: [{ cssSrc: googleFontsUrl }],
          appearance,
          fetchClientSecret,
        });

        setStripeConnectInstance(instance);
      } catch (error) {
        Honeybadger.notify(error);
      }
    };

    initializeStripe();
  }, []);

  return {
    stripeConnectInstance,
  };
};

export default useStripeConnect;
